// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__VwjzI","cardTitle":"Cards_cardTitle__EIxbQ","cardImageWrapper":"Cards_cardImageWrapper__jVlob","cardImage":"Cards_cardImage___HFm1"};